import {
  Image,
  LazyPicture,
  TextAlignment,
} from '@volkswagen-onehub/components-core';
import * as React from 'react';
import Div from '../components/Div.styled';
import ButtonLottie from '../components/LottieButtonStartCTA';
import TypographyBody from '../components/Typography/TypographyBody';
import TypographyHeading from '../components/Typography/TypographyHeading';
import useMediaQuery from '../hooks/useMediaQuery';
import {config} from '../environment';
import {useHistory, useLocation} from 'react-router-dom';

type Props = {
  surveyLandingUrl?: string;
};

export default function SurveyLandingPage({surveyLandingUrl}: Props) {
  const {isMobile} = useMediaQuery();
  const location = useLocation();
  const history = useHistory();
  const path = location && location.pathname;

  const onClickStart = () => {
    if (process.env.NODE_ENV === 'development') {
      history.push(`${path}start`);
      return;
    }
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const domain = url.origin;
    setTimeout(function () {
      window.location.href = `${domain}${surveyLandingUrl}`;
    }, 250);
  };

  return (
    <Div
      customStyles={{
        position: 'relative',
        backgroundImage: `url(${config.EV_FIT_ASSETS_BASE_URL}evw_fit_background.png)`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        textAlign: 'center',
        paddingTop: 80,
        transformOrigin: 'center bottom',
        maxHeight: 720,
      }}
    >
      <Div maxWidth={isMobile ? '326px' : '551px'} margin="0 auto">
        <Div
          customStyles={{
            maxWidth: isMobile ? '326px' : '530px',
          }}
        >
          <TypographyHeading textAlign={TextAlignment.center} size="large">
            Let us help you,
          </TypographyHeading>
          <TypographyHeading textAlign={TextAlignment.center} size="large" bold>
            find your EV Fit
          </TypographyHeading>
          <TypographyBody
            textAlign={TextAlignment.center}
            size="body"
            style={{margin: '24px 0 30px'}}
          >
            Find an EV that suits you best and help you navigate the world of
            electric mobility.
          </TypographyBody>
          <ButtonLottie onClick={onClickStart} />
        </Div>
        <Div
          customStyles={{
            transform: 'translateY(40px)',
            margin: '0 auto',
            maxWidth: isMobile ? 326 : 550,
          }}
        >
          <LazyPicture>
            <source
              srcSet={config.EV_FIT_ASSETS_BASE_URL + 'evwfit_car.png'}
              media="(min-width: 1440px)"
            />
            <Image
              src={config.EV_FIT_ASSETS_BASE_URL + 'evwfit_car.png'}
              width={'100%'}
              height={'auto'}
              alt="Car Banner"
              key={'car-banner'}
            />
          </LazyPicture>
        </Div>
      </Div>
    </Div>
  );
}
